import React, { useEffect, useState, useRef, useLayoutEffect } from 'react';
import classnames from 'classnames';
import './ScrollWrapper.css';
import GlobalProps from '../globalProps';

export interface Props extends GlobalProps {
  children?: React.ReactNode;
  direction?: 'vertical' | 'horizontal';
  padding?: string;
}

export function ScrollWrapper({ children, className, style, direction = 'vertical', padding }: Props): JSX.Element {
  const contentRef: React.MutableRefObject<HTMLDivElement | null> = useRef(null);
  const [startShadow, setStartShadow] = useState(false);
  const [endShadow, setEndShadow] = useState(true);

  function checkScrolled(): void {
    const elem = contentRef && contentRef.current;

    if (elem) {
      if (direction === 'horizontal') {
        if (elem.scrollLeft === 0) {
          setStartShadow(false);
        } else {
          setStartShadow(true);
        }

        if (elem.scrollLeft >= elem.scrollWidth - elem.offsetWidth) {
          setEndShadow(false);
        } else {
          setEndShadow(true);
        }
      } else {
        if (elem.scrollTop === 0) {
          setStartShadow(false);
        } else {
          setStartShadow(true);
        }

        if (elem.scrollTop >= elem.scrollHeight - elem.offsetHeight) {
          setEndShadow(false);
        } else {
          setEndShadow(true);
        }
      }
    }
  }

  useLayoutEffect(() => {
    const elem = contentRef?.current;

    if (elem) {
      elem.addEventListener('scroll', checkScrolled);
    }
    window.addEventListener('resize', checkScrolled);

    return () => {
      if (elem) {
        elem.removeEventListener('scroll', checkScrolled);
        window.removeEventListener('resize', checkScrolled);
      }
    };
  }, []);

  // Necesary to display shadow without scrolling first
  useEffect(() => {
    const elem = contentRef?.current;

    if (elem) {
      checkScrolled();
    }
  });

  return (
    <div
      className={classnames(className, 'scroll-wrapper', `scroll-wrapper--${direction}`, {
        'scroll-wrapper--with-padding': !!padding,
      })}
      style={style}
    >
      <div
        className={classnames('scroll-wrapper__shadow', 'scroll-wrapper__shadow--start', {
          'scroll-wrapper__shadow--visible': startShadow,
        })}
        style={direction === 'horizontal' ? { width: padding } : { height: padding }}
      ></div>
      <div className="scroll-wrapper__content" ref={contentRef}>
        {children}
      </div>
      <div
        className={classnames('scroll-wrapper__shadow', 'scroll-wrapper__shadow--end', {
          'scroll-wrapper__shadow--visible': endShadow,
        })}
        style={direction === 'horizontal' ? { width: padding } : { height: padding }}
      ></div>
    </div>
  );
}
